import { render, staticRenderFns } from "./purchaseReturnRecord.vue?vue&type=template&id=3f8ec464"
import script from "./purchaseReturnRecord.vue?vue&type=script&lang=js"
export * from "./purchaseReturnRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports